export enum UserRolesEnum {
  GLOBAL_ADMIN = 'global-admin',
  WORKSPACE_ADMIN = 'workspace-admin',
}
